import { call, put, takeLatest } from "redux-saga/effects";
import { TreatmentPlanTemplatesAPI } from "../../../api/treatmentPlansAPI";
import {
  GET_MEDICATION_TEMPLATES_ERROR,
  GET_MEDICATION_TEMPLATES_REQUEST,
  GET_MEDICATION_TEMPLATES_SUCCESS,
} from "../../actions";

function* workerGetMedicationTemplates(): Generator<any> {
  try {
    const data: any = yield call(
      TreatmentPlanTemplatesAPI.getMedicationTemplates,
    );
    yield put({
      type: GET_MEDICATION_TEMPLATES_SUCCESS,
      payload: { templates: data }
    });
  } catch (error: any) {
    yield put({
      type: GET_MEDICATION_TEMPLATES_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
  }
}

export function* watcherGetMedicationTemplates() {
  yield takeLatest(
    GET_MEDICATION_TEMPLATES_REQUEST,
    workerGetMedicationTemplates
  );
}
